import { EChartsOption } from 'echarts';
import { TableCellChartData } from './parseTableCellChartData';

const TOOLTIP_GAP_BELOW_CHART = 4;

export const tableCellTooltipPosition = (
  point: number[],
  _params: unknown,
  _dom: unknown,
  _rect: unknown,
  size: { viewSize: number[]; contentSize: number[] },
): [number, number] => {
  const tooltipWidth = size.contentSize[0];
  const x = Math.max(
    0,
    Math.min(point[0] - tooltipWidth / 2, size.viewSize[0] - tooltipWidth),
  );
  // Place below the chart area so tooltip does not cover the sparkline.
  const y = size.viewSize[1] + TOOLTIP_GAP_BELOW_CHART;
  return [x, y];
};

export function buildChartOptionFromTemplate(
  template: string,
  parsed: TableCellChartData,
): EChartsOption {
  // eslint-disable-next-line no-new-func
  const runner = new Function(
    'header',
    'data',
    `${template}\nreturn option;`,
  ) as (header: string[], data: (string | number)[][]) => EChartsOption;

  const option = runner(parsed.header, parsed.data);
  if (!option || typeof option !== 'object') {
    throw new Error('Chart template must define an `option` object');
  }
  return applyTableCellTooltipDefaults(option);
}

function applyTableCellTooltipDefaults(option: EChartsOption): EChartsOption {
  const defaults = {
    renderMode: 'html' as const,
    appendToBody: true,
    confine: false,
    transitionDuration: 0,
    position: tableCellTooltipPosition,
    className: 'datart-table-cell-chart-tooltip',
  };

  if (option.tooltip === undefined) {
    return { ...option, tooltip: defaults };
  }

  if (typeof option.tooltip === 'object' && !Array.isArray(option.tooltip)) {
    const userTooltip = option.tooltip;
    return {
      ...option,
      tooltip: {
        ...defaults,
        ...userTooltip,
        renderMode: userTooltip.renderMode ?? defaults.renderMode,
        appendToBody: userTooltip.appendToBody ?? defaults.appendToBody,
        transitionDuration:
          userTooltip.transitionDuration ?? defaults.transitionDuration,
        position: tableCellTooltipPosition,
        className: userTooltip.className ?? defaults.className,
      },
    };
  }

  return option;
}
